
<div class="image">
  <directory-icon [directory]="directory"></directory-icon>
</div>
<div class="bottom no-wrap" data-test-qa="name">{{name}}</div>
<media-item-labels data-test-qa="rating" [directory]="directory" [location]="location" [showOffline]="true" [root]="root"></media-item-labels>
<checkbox class="media-huge-checkbox" *ngIf="selectable" [checked]="mediaBrowserSelection.isSelected(directory)" (click)="onCheckbox($event)"></checkbox>